/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Templates_Personal_MarkerInputs */



/**
* | output |
* | --- |
* | "Personal" |
*
* @param {Settings_Templates_Personal_MarkerInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const settings_templates_personal_marker = /** @type {((inputs?: Settings_Templates_Personal_MarkerInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Templates_Personal_MarkerInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Persoonlijk")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Personnel")
	return /** @type {LocalizedString} */ ("Personal")
});